import { redirect } from "next/navigation";
export default function ResetRequestsRedirectPage() {
  redirect("/admin/profile?tab=reset");
}
